<!--Loading Div-->
<sim-component-loading-container
	[isLoading]="loadingData"
	[errorLoading]="!loadingData && !data"
	[loadingMessage]="T.GLOBAL_TEXT_LOADING | translate"
	[errorMessage]="T.MEDIA_LIBRARY_ERROR_LOADING_VOGSET | translate"
	[loadingIcon]="'fad fa-volume-up'"
	[fullWidthLoadingCon]="true"
	[showBackDrop]="true"
/>

<div
	class="baseContainer container-fluid d-flex h-100 flex-column twoScreenPageWrapper"
	[class.isLoading]="loadingData || (!loadingData && !data)"
>
	<div class="row headerTitleRow">
		<div class="col-12 headerTitleColumn">
			<div class="backButton">
				<button
					mat-icon-button
					color="accent"
					matTooltip="{{ T.SCENARIO_LIBRARY_BOOKMARK_BACK_TO_LIBRARIES | translate }}"
					matTooltipClass="accent"
					(click)="historyBack()"
				>
					<mat-icon fontSet="fad" fontIcon="fa-arrow-left" inline />
				</button>
			</div>
			<div class="icon">
				<mat-icon [fontSet]="icon?.fontSet" [fontIcon]="icon?.fontIcon" inline />
			</div>
			<div class="mat-headline-4 nomargin">
				{{ title }}
			</div>
			<div class="addEntryButtonContainer">
				<button mat-fab color="accent" class="addEntryButton" (click)="downloadClickedEmitter.emit()">
					<ng-container>
						<mat-icon fontSet="fad" fontIcon="fa-download" inline />
					</ng-container>
				</button>
			</div>
		</div>

		<div class="col-12">
			<mat-divider class="headerDivider" />
		</div>
	</div>

	<div class="container editingContent">
		<div class="row">
			<div class="col-12">
				<!-- Content for Edit Form -->
				<ng-content select="[editForm]" />
			</div>
		</div>

		<div class="row dividerRow">
			<div class="col-12">
				<mat-divider />
			</div>
		</div>

		<div class="row">
			<div class="col-6 selectedVogMedias">
				<div class="title">
					{{
						T.SHARED_BASIC_ADMINISTRATION_MEDIA
							| translate
								: {
										type:
											(mediaTypes.length > 1
												? T.SHARED_BASIC_ADMINISTRATION_MEDIA_FILES
												: T.SHARED_BASIC_ADMINISTRATION_MEDIA_AUDIO
											) | translate,
								  }
					}}
				</div>
			</div>

			<div class="col-6 availableVogMedias" [class.searching]="searching">
				<div class="title">
					{{ T.SHARED_BASIC_ADMINISTRATION_MEDIA_AVAILABLE | translate }}
				</div>
				<div class="searchField">
					<mat-form-field class="full-width-form" color="accent">
						<mat-label>{{ T.SHARED_BASIC_ADMINISTRATION_MEDIA_SEARCH_VALUE | translate }}</mat-label>
						<input autofocus matInput placeholder="..." [formControl]="searchInputControl" />
					</mat-form-field>
				</div>
				<div class="addMediaToLib">
					<button mat-icon-button color="accent" (click)="searching = !searching">
						<mat-icon fontSet="fad" fontIcon="fa-search" inline />
					</button>

					<button mat-icon-button color="accent" (click)="uploadClickedEmitter.emit(mediaTypes[selectedTabIndex])">
						<mat-icon fontSet="fad" fontIcon="fa-upload" inline />
					</button>
				</div>
			</div>
		</div>

		<div class="row dragDroppingRow">
			<div class="col-6 h-100 overflowAuto">
				@if (!loadingData) {
					<div
						class="selectedVogMediasContainer"
						[@zoomInOnEnter]
						(cdkDropListDropped)="mediaDroppedSelectedEmitter.emit($event)"
						id="selectedMedias"
						[cdkDropListConnectedTo]="availableMediaDropListIds"
						cdkDropList
					>
						@if (data?.length === 0) {
							<div class="noVOGSounds">
								<i class="fad fa-volume-up fa-3x"></i>
								{{ T.SHARED_BASIC_ADMINISTRATION_NO_VOG_SOUND | translate }}
								<br />
								{{ T.SHARED_BASIC_ADMINISTRATION_ADD_SOUND | translate }}
							</div>
						}
						@for (vogSetMedia of data; track TrackByMethods.trackById(i, vogSetMedia); let i = $index) {
							<div class="sound-card sound-card-fromAvailable" [@anim]="'active'">
								<sim-media-card-list
									[media]="vogSetMedia"
									[index]="i"
									[showDeleteButton]="true"
									[useRemoveIcon]="true"
									[showPreview]="
										vogSetMedia.mediaType !== MediaType.PDF && vogSetMedia.mediaType !== MediaType.PowerPoint
									"
									[progress]="vogSetMedia['progress']"
									[active]="vogSetMedia['isPlaying']"
									[showLoopButton]="false"
									[showEditButton]="true"
									(editButtonClicked)="editMediaEmitter.emit(vogSetMedia)"
									(deleteButtonClicked)="
										removeMediaFromSelectedEmitter.emit({
											item: vogSetMedia,
											index: i,
										})
									"
									(mediaClicked)="mediaClickedEmitter.emit(vogSetMedia)"
									[isDraggable]="true"
								/>
							</div>
						}
					</div>
				}
			</div>

			<div class="col-6 h-100">
				<mat-tab-group
					[mat-stretch-tabs]="false"
					[class.hideTabHeader]="mediaTypes?.length === 1"
					[(selectedIndex)]="selectedTabIndex"
					color="accent"
					class="h-100 mediaHolderTabGroup"
					#availableMediaTabs
				>
					@for (mediaType of mediaTypes; track mediaType) {
						<mat-tab [label]="MediaType[mediaType]">
							<ng-template matTabContent>
								@if (availableData && !loadingAvailableData) {
									<div
										class="availableVogMediasContainer"
										cdkDropList
										(cdkDropListDropped)="mediaDroppedAvailableEmitter.emit($event)"
										[id]="'availableMedias' + mediaType"
										cdkDropListConnectedTo="selectedMedias"
									>
										@if (!loadingData && (!availableData[mediaType] || availableData[mediaType].length === 0)) {
											<div class="noMediaForThisType">
												@switch (mediaType) {
													@case (MediaType.Audio) {
														<i class="fad fa-3x fa-volume-up"></i>
													}
													@case (MediaType.PDF) {
														<i class="fad fa-3x fa-file-pdf"></i>
													}
													@case (MediaType.Excel) {
														<i class="fad fa-3x fa-file-excel"></i>
													}
													@case (MediaType.Image) {
														<i class="fad fa-3x fa-image-polaroid"></i>
													}
													@case (MediaType.PowerPoint) {
														<i class="fad fa-3x fa-file-powerpoint"></i>
													}
													@case (MediaType.Video) {
														<i class="fad fa-3x fa-file-video"></i>
													}
													@default {
														<i class="fad fa-3x fa-edit"></i>
													}
												}
												{{ T.SHARED_BASIC_ADMINISTRATION_NO_MEDIA_FOUND | translate }}
											</div>
										}
										@if (asMedias(availableData[mediaType])?.length > 0) {
											<cdk-virtual-scroll-viewport itemSize="90" class="withoutVirtualContainer">
												<div
													class="sound-card"
													*cdkVirtualFor="
														let vogSetMedia of asMedias(availableData[mediaType]);
														let i = index;
														trackBy: TrackByMethods.trackById;
														templateCacheSize: 0
													"
												>
													<sim-media-card-list
														[showPreview]="
															vogSetMedia.mediaType !== MediaType.PDF &&
															vogSetMedia.mediaType !== MediaType.PowerPoint
														"
														[media]="vogSetMedia"
														[index]="i"
														[showDeleteButton]="true"
														[showAddButton]="true"
														[showLoopButton]="false"
														[showEditButton]="true"
														[progress]="vogSetMedia['progress']"
														[active]="vogSetMedia['isPlaying']"
														(addButtonClicked)="
															addMediaToSelectedEmitter.emit({
																item: vogSetMedia,
																index: i,
															})
														"
														(mediaClicked)="mediaClickedEmitter.emit(vogSetMedia)"
														(editButtonClicked)="editMediaEmitter.emit(vogSetMedia)"
														(deleteButtonClicked)="deleteMedia(vogSetMedia)"
														[isDraggable]="true"
													/>
												</div>
											</cdk-virtual-scroll-viewport>
										}
									</div>
								}
							</ng-template>
						</mat-tab>
					}
				</mat-tab-group>
			</div>
		</div>
	</div>
</div>
